import { FiHeart, FiBookOpen, FiBriefcase, FiLayers, FiZap, FiCpu, FiTarget } from 'react-icons/fi'

const about = [
	{
		icon: FiHeart,
		title: 'The Spark',
		content:
			"My journey into technology didn't start with just learning how to code — it started with curiosity. I've always been fascinated by how ideas turn into systems, how logic turns into products, and how technology can quietly reshape everyday life. Over time, that curiosity evolved into a deep passion for building digital solutions that are not only functional, but meaningful and impactful."
	},
	{
		icon: FiBookOpen,
		title: 'Foundation',
		content:
			"As a Computer Science and Engineering graduate from Vellore Institute of Technology, I built a strong foundation in software development and analytical thinking. From mastering JavaScript, Java, and C++ to building applications using the MERN stack and Android development, I immersed myself in understanding how systems work — both at a conceptual and practical level. But I didn't stop at the basics. I pushed into Machine Learning, Artificial Intelligence, Blockchain, and Game Technology, constantly expanding my perspective in a rapidly evolving tech world."
	},
	{
		icon: FiBriefcase,
		title: 'At Wells Fargo',
		content:
			"Professionally, my journey has been about turning innovation into execution. At Wells Fargo, I focus on building tools that streamline release management, reduce manual effort, and optimize engineering workflows. The goal isn't just automation — it's reliability, scalability, and long-term efficiency. I enjoy designing systems that simplify complexity and empower teams to move faster with confidence."
	},
	{
		icon: FiLayers,
		title: 'Earlier Chapters',
		content:
			'Before that, at AI.HYR, I had the opportunity to work on recruitment automation — building solutions that significantly reduced human intervention and accelerated hiring cycles. At Samsung R&D, I explored conversational AI, contributing to intuitive voice-driven experiences. My experiences at Accenture and Spark Consultancy strengthened my understanding of cloud security, scalable architectures, and enterprise-grade web systems — shaping my approach to building robust, production-ready solutions.'
	},
	{
		icon: FiZap,
		title: 'Hackathons & Beyond',
		content:
			"Outside structured roles, I thrive in high-energy environments like hackathons, where creativity meets constraint. Winning competitions by solving real-world challenges taught me how to think strategically, prototype rapidly, and execute under pressure. Whether it was developing a decentralized data protection vault or launching Android applications with thousands of downloads, I've always aimed to merge innovation with usability."
	},
	{
		icon: FiCpu,
		title: 'Impact & Recognition',
		content:
			"For me, technology is more than engineering — it's a medium for transformation. My work has been recognized in competitions and publications across AI, blockchain, and cybersecurity. I enjoy mentoring developers, sharing ideas at seminars, and constantly asking one question: how can we build systems that are smarter, faster, and more human-centric?"
	},
	{
		icon: FiTarget,
		title: "The Builder's Mindset",
		content:
			"Today, I see myself not just as a developer, but as a builder of systems and experiences. I'm driven by the belief that thoughtful engineering can shape the future — and I'm always ready to collaborate with those who want to innovate boldly, solve meaningfully, and build responsibly. 🚀"
	}
]

export default about
